import React, { useEffect, useState } from "react";
import { RefreshCw, ShieldCheck } from "lucide-react";
import AdminLayout from "./AdminLayout";
import API from "../services/api";

function AdminGoogleAuth() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await API.get("/admin/google-auth");
      setData(res.data || null);
    } finally {
      setLoading(false);
    }
  };

  const regenerate = async () => {
    if (!window.confirm("Regenerate Google Authenticator code? Old codes will stop working.")) return;
    setLoading(true);
    try {
      const res = await API.post("/admin/google-auth/regenerate");
      setData(res.data || null);
      alert("New authenticator secret generated. Scan the new QR code.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <AdminLayout>
      <section style={page}>
        <div style={header}>
          <div>
            <h1 style={title}>Google Authenticator</h1>
            <p style={subtitle}>Require a 6-digit code every time admin logs in.</p>
          </div>
          <button type="button" style={refreshButton} onClick={load} disabled={loading}>
            <RefreshCw size={16} /> Refresh
          </button>
        </div>

        <section style={card}>
          <div style={badge}>
            <ShieldCheck size={18} />
            <strong>{data?.enabled ? "Enabled" : "Not Ready"}</strong>
          </div>

          <div style={setupGrid}>
            <div style={qrBox}>
              {data?.qr_url ? <img src={data.qr_url} alt="Google Authenticator QR" style={qrImage} /> : <div style={qrEmpty}>Loading...</div>}
            </div>

            <div style={steps}>
              <h3 style={cardTitle}>Setup Steps</h3>
              <p>1. Install Google Authenticator on your phone.</p>
              <p>2. Tap plus button and scan this QR code.</p>
              <p>3. On every admin login, enter the 6-digit code from the app.</p>
              <label style={fieldWrap}>
                <span style={fieldLabel}>Manual Secret</span>
                <input style={fieldInput} value={data?.secret || ""} readOnly />
              </label>
              <button type="button" style={dangerButton} onClick={regenerate} disabled={loading}>
                Regenerate Secret
              </button>
            </div>
          </div>
        </section>
      </section>
    </AdminLayout>
  );
}

const page = { display: "grid", gap: "18px" };
const header = { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" };
const title = { margin: 0, fontSize: "24px", fontWeight: 900 };
const subtitle = { margin: "6px 0 0", color: "#64748b" };
const refreshButton = { height: "42px", border: "1px solid #bfdbfe", borderRadius: "12px", background: "#eff6ff", color: "#2563eb", fontWeight: 800, display: "flex", alignItems: "center", gap: "8px", padding: "0 14px" };
const card = { background: "#fff", border: "1px solid #e2e8f0", borderRadius: "22px", padding: "22px", display: "grid", gap: "18px", boxShadow: "0 12px 28px rgba(15,23,42,0.06)" };
const badge = { width: "fit-content", display: "flex", alignItems: "center", gap: "8px", padding: "10px 14px", borderRadius: "999px", background: "#dcfce7", color: "#15803d" };
const setupGrid = { display: "grid", gridTemplateColumns: "260px minmax(0, 1fr)", gap: "22px", alignItems: "start" };
const qrBox = { width: "240px", height: "240px", borderRadius: "20px", border: "1px solid #dbe4f0", background: "#f8fafc", display: "grid", placeItems: "center", padding: "10px" };
const qrImage = { width: "220px", height: "220px", display: "block" };
const qrEmpty = { color: "#94a3b8", fontWeight: 800 };
const steps = { display: "grid", gap: "10px", color: "#334155" };
const cardTitle = { margin: 0, color: "#0f172a", fontSize: "18px", fontWeight: 900 };
const fieldWrap = { display: "grid", gap: "8px", marginTop: "8px" };
const fieldLabel = { color: "#64748b", fontSize: "12px", fontWeight: 800, textTransform: "uppercase" };
const fieldInput = { height: "48px", border: "1px solid #cbd5e1", borderRadius: "12px", padding: "0 14px", fontSize: "14px", fontWeight: 800, letterSpacing: "0.04em" };
const dangerButton = { width: "fit-content", height: "44px", border: 0, borderRadius: "12px", background: "#ef4444", color: "#fff", padding: "0 16px", fontWeight: 800 };

export default AdminGoogleAuth;
